import { Zone } from '../../interfaces'
import { GET_ZONES_EXITO, GET_ZONES } from '../types/zoneActionsTypes'

export type ZoneAction = ZonesAction | ZonesActionAsync

// Esto va a REDUX
export interface ZonesAction {
  type: typeof GET_ZONES_EXITO
  zones: Zone[] | undefined
  error: string | undefined
}

export const getZonesAction = (zones?: Zone[], error?: string): ZonesAction => {
  return {
    type: GET_ZONES_EXITO,
    zones,
    error
  }
}

// Esto va a SAGA
export interface ZonesActionAsync {
  type: typeof GET_ZONES
}

export const getZonesActionAsync = (): ZonesActionAsync => {
  return {
    type: GET_ZONES
  }
}
